import React, { Component } from 'react';
import PropTypes from 'prop-types';
import settings from '../../constants/settings.js';

class TwitterFollow extends Component {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        if (typeof (window.twttr) != 'undefined') {
            window.twttr.ready(() => {
                window.twttr.widgets.load();
            });            
        } 
    }

    render() {        
        return (
            <span className="btn-likeflw twfollow">
                <a href={`https://twitter.com/${this.props.username}`} className="twitter-follow-button" data-show-count="false" data-lang="en" data-show-screen-name="false" />
            </span>
        );
    }
}

TwitterFollow.propTypes = {
    username: PropTypes.string.isRequired
};

export default TwitterFollow;
